import { FeedbackCollectionFixture } from "@/components/feedback/types";

// EXTRACT: candidate for libs/ui or a shared fixtures package — these are the
// two surveys Rubicon will ship out of the box: a citizen satisfaction survey
// and a generic post-interaction feedback survey.

const CITIZEN_SATISFACTION_FEEDBACK_CONFIG = {
  headerView: "none",
  completedHtml:
    "<h3>We appreciate your feedback.</h3><p>Thank you for taking the time to provide your feedback. We will use your feedback to improve our service.</p>",
  loadingHtml: "<h3>Loading Feedback Survey...</h3>",
  pages: [
    {
      name: "condensed_report",
      elements: [
        {
          type: "boolean",
          name: "isSatisfied",
          title: "HOW WOULD YOU RATE YOUR EXPERIENCE USING ONLINE REPORTING?",
          labelTrue: "Satisfied 👍",
          labelFalse: "Not Satisfied 👎",
          swapOrder: true,
        },
        {
          type: "checkbox",
          name: "feedbackReasons-satisfied",
          visibleIf: "{isSatisfied} = true",
          minWidth: "158px",
          title: "WHAT WORKED WELL?",
          choices: [
            "Intuitive flow",
            "Clear questions",
            "Easy attachment upload",
            "Instant notifications",
            "Unfinished report recovery",
          ],
          showOtherItem: true,
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "feedbackReasons-unsatisfied",
          visibleIf: "{isSatisfied} = false",
          minWidth: "158px",
          title: "WHAT PROBLEMS DID YOU RUN INTO?",
          choices: [
            "Confusing",
            "Slow",
            "Upload failed",
            "Technical issues",
            "Hard to find",
          ],
          showOtherItem: true,
          colCount: 2,
        },
        {
          type: "comment",
          name: "feedbackDescription-satisfied",
          visibleIf: "{isSatisfied} = true",
          title: "ADDITIONAL DETAILS",
          maxLength: 2000,
          rows: 1,
          autoGrow: true,
        },
        {
          type: "comment",
          name: "feedbackDescription-notSatisfied",
          visibleIf: "{isSatisfied} = false",
          title: "ADDITIONAL DETAILS",
          maxLength: 2000,
          rows: 1,
          autoGrow: true,
        },
      ],
    },
  ],
  showNavigationButtons: false,
  autoAdvanceAllowComplete: false,
  clearInvisibleValues: "onHidden",
  completeText: "SAVE",
  showPreviewBeforeComplete: true,
};

const GENERAL_FEEDBACK_CONFIG = {
  autoAdvanceAllowComplete: false,
  clearInvisibleValues: "onHidden",
  completedHtml:
    "<h3>Thank you.</h3><p>Your feedback helps us serve our community better.</p>",
  completeText: "Submit Feedback",
  headerView: "none",
  loadingHtml: "<h3>Loading Feedback Survey...</h3>",
  pages: [
    {
      name: "page1",
      title: "General Feedback",
      elements: [
        {
          type: "boolean",
          name: "wasPositive",
          title: "Was your overall experience with us positive?",
          isRequired: true,
          labelFalse: "No 👎",
          labelTrue: "Yes 👍",
          swapOrder: true,
        },
        {
          type: "checkbox",
          name: "positiveAspects",
          title: "What stood out?",
          description: "(Select all that apply)",
          colCount: 2,
          showOtherItem: true,
          visibleIf: "{wasPositive} = true",
          choices: [
            "Professional staff",
            "Quick response",
            "Clear communication",
            "Respectful treatment",
            "Issue resolved",
          ],
        },
        {
          type: "checkbox",
          name: "improvementAreas",
          title: "Where could we improve?",
          description: "(Select all that apply)",
          colCount: 2,
          showOtherItem: true,
          visibleIf: "{wasPositive} = false",
          choices: [
            "Wait time",
            "Communication",
            "Staff demeanor",
            "Outcome",
            "Accessibility",
          ],
        },
        {
          type: "comment",
          name: "additionalComments",
          title: "Anything else you'd like to share?",
          maxLength: 2000,
          placeholder: "Optional — your detailed feedback helps us improve.",
        },
      ],
    },
  ],
  showNavigationButtons: false,
  showQuestionNumbers: false,
};

export const CITIZEN_SATISFACTION_COLLECTION_ID =
  "00000000-0000-0000-0000-000000000001";
export const GENERAL_FEEDBACK_COLLECTION_ID =
  "00000000-0000-0000-0000-000000000002";

export const FEEDBACK_COLLECTION_FIXTURES: FeedbackCollectionFixture[] = [
  {
    id: CITIZEN_SATISFACTION_COLLECTION_ID,
    name: "Citizen Satisfaction Feedback",
    surveyjs_configuration: CITIZEN_SATISFACTION_FEEDBACK_CONFIG,
  },
  {
    id: GENERAL_FEEDBACK_COLLECTION_ID,
    name: "General Feedback",
    surveyjs_configuration: GENERAL_FEEDBACK_CONFIG,
  },
];

export const getCollectionById = (
  id: string,
): FeedbackCollectionFixture | undefined =>
  FEEDBACK_COLLECTION_FIXTURES.find((c) => c.id === id);
